import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { EnvService } from "./env.service";

@Injectable({
  providedIn: 'root'
})
export class ProsService {
  USER: any;

  constructor(
    private env: EnvService,
    private http: HttpClient
  ) {}

  getUserData(): void {
    this.USER = JSON.parse(localStorage.getItem('currentUser'));
  }

  public getClubList(): Observable<any> {
    const url = `${this.env.apiBase}/club`;
    this.getUserData();
    let params = new HttpParams()
      .append('userId', this.USER.id);
    return this.http.get<Object>(url, {params});
  }

  public getSpecialityList(): Observable<any> {
    const url = `${this.env.apiBase}/speciality`;
    this.getUserData();
    let params = new HttpParams()
      .append('userId', this.USER.id);
    return this.http.get<Object>(url, {params});
  }

  public getProsList(data): Observable<any> {
    const url = `${this.env.apiBase}/web/operator/users`;
    this.getUserData();
    let options;
    let headers = new HttpHeaders()
      .append('ignoreLoadingBar', 'true');
    let params = new HttpParams()
      .append('userId', this.USER.id)
      .append('club_id', data.club)
      .append('search_value', data.search_value)
      .append('per_page', data.per_page)
      .append('page', data.page)
      .append('order_field', data.order_field)
      .append('order', data.order)
      .append('user_type', '2');

    if (data['ignoreBar']) {
      options = {
        params: params,
        headers: headers
      };
    } else {
      options = {
        params: params
      };
    }

    return this.http.get<Object>(url, options);
  }

  public getSingleProData(data): Observable<any> {
    const url = `${this.env.apiBase}/web/operator/users`;
    this.getUserData();
    let params = new HttpParams()
      .append('userId', this.USER.id)
      .append('user_id', data.id);
    return this.http.get<Object>(url, {params});
  }

  public getSingleProTransactions(data): Observable<any> {
    const url = `${this.env.apiBase}/web/operator/user/payment`;
    this.getUserData();
    let params = new HttpParams()
      .append('userId', this.USER.id)
      .append('month', data.month)
      .append('year', data.year)
      .append('user_id', data.id);
    return this.http.get<Object>(url, {params});
  }

  public createNewPro(data): Observable<any> {
    const url = `${this.env.apiBase}/web/operator/user`;
    let params = new HttpParams()
      .append('userId', this.USER.id);
    return this.http.post<Object>(url, data, {params});
  }

  public sendPushMessage(data): Observable<any> {
    const url = `${this.env.apiBase}/push`;
    let params = new HttpParams()
      .append('userId', this.USER.id)
      .append('message', data.message)
      .append('send_to_all', data.send_to_all);
    return this.http.post<Object>(url, {}, {params});
  }

  public importCSVProList(file): Observable<any> {
    const url = `${this.env.apiBase}/user/import`;
    const formData: FormData = new FormData();
    formData.append('csv', file, file.name);
    this.getUserData();
    let params = new HttpParams()
      .append('userId', this.USER.id);

    return this.http.post(url,  formData, {params});
  }

  public deleteProUser(data): Observable<any> {
    const url = `${this.env.apiBase}/user`;
    let params = new HttpParams()
      .append('userId', this.USER.id)
      .append('user_id', data.user_id);
    return this.http.delete<Object>(url, {params});
  }

}
